import { BuyerInput } from '../data/tools';
import { Recommendation, buildLeadSummary, buyerIntentScore } from './recommender';

export interface LeadRecord {
  id: string;
  email: string;
  company?: string;
  intentScore: number;
  summary: string;
  createdAt: string;
}

const STORAGE_KEY = 'aitbc_leads';

export function persistLead(input: BuyerInput, recommendations: Recommendation[]): LeadRecord {
  const email = input.email?.trim() || 'anonymous@example.invalid';
  const lead: LeadRecord = {
    id: `lead_${Date.now()}`,
    email,
    company: input.company?.trim() || undefined,
    intentScore: buyerIntentScore(input),
    summary: buildLeadSummary(input, recommendations),
    createdAt: new Date().toISOString(),
  };
  try {
    const previous = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') as LeadRecord[];
    localStorage.setItem(STORAGE_KEY, JSON.stringify([lead, ...previous].slice(0, 30)));
  } catch {
    // Local persistence is best effort until a CRM/backend is connected.
  }
  return lead;
}
